/**
 * Handles the beforeunload event by preventing the default behavior and setting an empty return value.
 *
 * @param {any} e - The event object for the beforeunload event.
 * @return {void} No return value.
 */
export const handleBeforeUnload = (e: Event): void => {
  return e.preventDefault();
};
